
export default function Footer() {
  return (
    <footer className="bg-black text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-yellow-500 rounded-lg flex items-center justify-center">
                <i className="ri-road-map-line text-black text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-black tracking-tight">
                  Bollard Installation Essex
                </h3>
              </div>
            </div>
            <p className="text-gray-400 mb-4">
              Professional bollard installation specialists in Essex, providing telescopic, fold down, and electric bollards for residential and commercial properties.
            </p>
            <div className="flex space-x-4">
              <i className="ri-facebook-fill text-yellow-500 text-xl cursor-pointer hover:text-yellow-400"></i>
              <i className="ri-twitter-fill text-yellow-500 text-xl cursor-pointer hover:text-yellow-400"></i>
              <i className="ri-linkedin-fill text-yellow-500 text-xl cursor-pointer hover:text-yellow-400"></i>
              <i className="ri-instagram-fill text-yellow-500 text-xl cursor-pointer hover:text-yellow-400"></i>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-500">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="/" className="text-gray-400 hover:text-white cursor-pointer">Home</a></li>
              <li><a href="/#services" className="text-gray-400 hover:text-white cursor-pointer">Services</a></li>
              <li><a href="/areas" className="text-gray-400 hover:text-white cursor-pointer">Areas Covered</a></li>
              <li><a href="/#about" className="text-gray-400 hover:text-white cursor-pointer">About Us</a></li>
              <li><a href="/#contact" className="text-gray-400 hover:text-white cursor-pointer">Contact</a></li>
              <li><a href="/quote" className="text-gray-400 hover:text-white cursor-pointer">Detailed Quote Request</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-500">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <i className="ri-map-pin-line text-yellow-500"></i>
                <span className="text-gray-400">Essex, United Kingdom</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-yellow-500"></i>
                <a href="tel:+447834858178" className="text-gray-400 hover:text-yellow-500 cursor-pointer">+44 7834 858178</a>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-yellow-500"></i>
                <span className="text-gray-400">info@bollardinstallationessex.co.uk</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-time-line text-yellow-500"></i>
                <span className="text-gray-400">Mon-Fri: 8AM-6PM</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-500">Service Areas</h4>
            <ul className="space-y-2">
              <li><a href="/areas" className="text-gray-400 hover:text-yellow-500 cursor-pointer transition-colors">Chelmsford</a></li>
              <li><a href="/areas" className="text-gray-400 hover:text-yellow-500 cursor-pointer transition-colors">Colchester</a></li>
              <li><a href="/areas" className="text-gray-400 hover:text-yellow-500 cursor-pointer transition-colors">Basildon</a></li>
              <li><a href="/areas" className="text-gray-400 hover:text-yellow-500 cursor-pointer transition-colors">Southend-on-Sea</a></li>
              <li><a href="/areas" className="text-gray-400 hover:text-yellow-500 cursor-pointer transition-colors">Harlow</a></li>
              <li><a href="/areas" className="text-gray-400 hover:text-yellow-500 cursor-pointer transition-colors">View All Areas →</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Bollard Installation Essex. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-white text-sm cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-gray-400 hover:text-white text-sm cursor-pointer">Terms of Service</a>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm cursor-pointer">Website Builder</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
